export default {
  title: 'Liity mukaan, {{name}}!',
  default_program_name: 'Kanta-asiakasohjelma',
  savings_highlight: {
    title: 'Saat palkkioita. Joka tilauksesta, aina.',
    subtitle: 'Rekisteröidy sekunneissa ja ala kerätä pisteitä.',
  },
  how_it_works: {
    label: 'Näin se toimii',
    step_1: {
      title: 'Rekisteröidy 30 sekunnissa',
      desc: 'Tarvitset vain puhelinnumerosi',
    },
    step_2: {
      title: 'Tilaa & ansaitse',
      desc: '{{percentage}} % takaisin jokaisesta tilauksesta',
    },
    step_3: {
      title: 'Lunasta & säästä',
      desc: 'Jopa {{amount}} alennusta per tilaus',
    },
  },
  profile: {
    verified_title: 'Puhelinnumero vahvistettu!',
    verified_subtitle: 'Täydennä profiilisi aloittaaksesi pisteiden keräämisen.',
  },
  form: {
    phone_number: {
      label: 'Puhelinnumero',
      description: 'Lähetämme vahvistuskoodin varmistaaksemme, että se olet sinä.',
      placeholder: 'Puhelinnumero',
    },
    birthday: {
      label: 'Syntymäpäivä — päivä ja kuukausi riittää lahjan saamiseksi 🥳',
      placeholder: 'Syntymäpäivä (valinnainen)',
      parts: {
        month: 'Kuukausi',
        day: 'Päivä',
      },
    },
  },
  terms:
    'Rekisteröitymällä hyväksyt <TermsLink>käyttöehtomme</TermsLink> ja <PrivacyPolicyLink>tietosuojakäytäntömme</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Jatka',
    verify: 'Vahvista',
    complete: 'Viimeistele rekisteröinti',
  },
  toasts: {
    login_success: 'Olet kirjautunut sisään onnistuneesti',
    invalid_code: 'Virheellinen koodi. Yritä uudelleen.',
    failed_to_update_profile: 'Profiilin päivitys epäonnistui. Yritä uudelleen.',
  },
};
